export enum ScheduledReportFrequency {
    UNKNOWN,
    DAILY,
    WEEKLY,
    MONTHLY,
    MANUAL,
}
